
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solution",
      function () {
        return require("private-next-pages/solution/index.js");
      }
    ]);
  